module.exports = __webpack_public_path__ + "img/ThermostatOutlined.adc1990d.svg";